<template>
  <div v-if="flag">
    <slot :model="model"></slot>
  </div>
</template>
<script>
  import { getCookie } from '@/utils/cookies'
  import userinfoService from '@/services/bylBaseCenter/user/userinfo'
  export default {
    data() {
      return {
        flag: false,
        model: {}
      }
    },
    created () {
      var userId = getCookie(process.env.USERID_KEY) || ''
      userinfoService.getUser(userId).then((r) => {
        this.model = r.data
        this.flag = true
      })
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/containers/auth/containerUser.vue